import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/EY-quiz-illustration.svg'


const _withScopeId = n => (_pushScopeId("data-v-5c8e412c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "main"
}
const _hoisted_2 = { class: "main-row" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  draggable: "false"
}, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "two-spacer" }, null, -1))
const _hoisted_5 = { class: "form" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "title" }, "Jdeme do finále", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "description" }, " Jsi skoro na konci. Už vím, jaké oddělení pro tebe bude nejlepší. Teď jen potřebuju tvůj e‑mail, ať vím, kam ti výsledek poslat. ", -1))

import { ref } from "vue";
import { useStore } from "vuex";
import FinalForm from "@/components/FinalForm.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'FinalFormScreen',
  setup(__props) {

const store = useStore();

const isActive = ref(false);

store.subscribe((mutation) => {
  if (mutation.type === "finish") {
    isActive.value = true;
  }
  if (mutation.type === "submit") {
    isActive.value = false;
  }
});

return (_ctx: any,_cache: any) => {
  return (isActive.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _hoisted_7,
            _createVNode(FinalForm)
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})